RivalIQ.module('export.models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    const VALID_ADVANCED_OPTIONS = ['focusCompanyId', 'activeSources', 'scheduleOffset', 'companySetDescriptor'];

    const AdvancedScheduleOptions = models.AdvancedScheduleOptions = Backbone.Model.extend({
        validate: function (attrs) {
            const errors = [];

            const keys = _.without(_.keys(attrs), 'companySetDescriptor');
            const invalidKeys = _.difference(keys, VALID_ADVANCED_OPTIONS);

            _.each(invalidKeys, function (option) {
                errors.push(['invalidOption', `Invalid Advanced Option: ${option}`]);
            });

            // all advanced options but companySetDescriptor should be numbers
            _.each(keys, function (option) {
                if (_.exists(attrs[option]) && !_.isNumber(attrs[option]) && option !== 'companySetDescriptor') {
                    errors.push(['invalidType', `Invalid Type: ${option} must be a number.`]);
                }
            });

            if (!errors.length) {
                return null;
            }

            return errors;
        },

        // defaultCompanySetDescriptor: defines a fallback for when an advanced settings company set is either not set or invalid. Use cases:
        //    - a new schedule export modal: defaultCompanySetDescriptor = current state company set
        //    - edit scheduled report modal: defaultCompanySetDescriptor = the report's company set
        // defaultCompanySetDescriptor should be a companySetDescriptor or an object like {id: companySetDescriptor}
        getCompanySet: function (defaultCompanySetDescriptor) {
            const me = this;
            let fullCompanySet;

            const companySetDescriptor = me.get('companySetDescriptor');
            if (companySetDescriptor) {
                fullCompanySet = RivalIQ.state.companySets.get(companySetDescriptor);
            } else {

                const advancedCompanySet = me.get('companySetDescriptor');
                if (advancedCompanySet) {
                    fullCompanySet = RivalIQ.state.companySets.get(advancedCompanySet);
                } else if (defaultCompanySetDescriptor) {
                    fullCompanySet = RivalIQ.state.companySets.get(defaultCompanySetDescriptor);
                }
            }

            // #14176 remove focus company only until we can get a real fix
            if (!fullCompanySet || RivalIQ.state.utils.isOnlyCompanySet(fullCompanySet.id)) {
                // can only return 'All' since none of the preferred tags are valid
                fullCompanySet = RivalIQ.state.companySets.findWhere({
                    id: RivalIQ.state.companySets.none
                });
            }
            return fullCompanySet;
        },

        // assume company set is always defined (use me.getCompanySet())
        getCompanySetName: function (companySet) {
            const me = this;
            if (RivalIQ.state.utils.isOnlyCompanySet(companySet.id)) {
                return `Only ${me.getFocusCompanyName()}`;
            } else {
                return companySet.get('name');
            }
        },

        getFocusCompanyName: function () {
            const me = this;
            const focusCompanyId = me.get('focusCompanyId');
            const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
            if (focusCompany) {
                return focusCompany.get('name');
            } else {
                // focusCompany was deleted
                return '--company not found--';
            }
        },

        getSupportedHideableSourceDetailsCollection: function () {
            return _.filter(RivalIQ.enums.hideableSourceDescriptions, function (channel) {
                return RivalIQ.state.account.channelSupported(channel.mask);
            });
        },

        isEnabled: function () {
            const me = this;
            return me.get('focusCompanyId') || me.get('activeSources');
        }

    });

    AdvancedScheduleOptions.validOptions = VALID_ADVANCED_OPTIONS;

});
